import Cookies from 'universal-cookie';


export default class AttributeCookies {
  constructor() {
    this.cookies = new Cookies();
    this.cookieName = 'uprfattributes';
  }

  getValue() {
    const cookieValue = this.cookies.get(this.cookieName);
    return cookieValue ? decodeURIComponent(cookieValue) : undefined;
  }

  getChildValue(key) {
    const value = this.getValue();
    if (!value) {
      return undefined;
    }

    const filterMatches = new RegExp(`(^${key}|&${key})=([^&]+)`, 'g').exec(value);
    return filterMatches && filterMatches[2];
  }

  setValue(value) {
    this.cookies.set(this.cookieName, value, {
      path: '/',
      secure: process.env.TEST_ENV !== 'test',
      httpOnly: false,
      sameSite: 'none',
    });
  }
}
